<template>
    <div class="arrow-wrapper">
        <div class="arrow-container">
            <div class="arrow left" ref="back">
                <img src="../assets/left-arrow.svg" alt="">
                <h1>{{ leftText }}</h1>
            </div>
            <div class="arrow right" ref="next">
                <img src="../assets/right-arrow.svg" alt="">
                <h1>{{ rightText }}</h1>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Arrows',
    props: ['leftText','rightText'],
    methods: {
        back() {
            // console.log("Clicked!");
            // this.$emit('changeComponent', '-1');
            this.$emit('arrowChangeComponent', -1);
        },
        next() {
            // console.log("Fuck this bullshit ass capstone, ON GOOOOODDDDDDDDD");
            // this.$emit('changeComponent', '1');
            this.$emit('arrowChangeComponent', 1);
        },
        roundColor() {
            this.$refs.back.style.backgroundColor = "transparent";
            this.$refs.next.style.backgroundColor = "#459300";
        },
        flatColor() {
            // this.$refs.navText.style.color = "#459300";
            this.$refs.back.style.backgroundColor = "#2D7BE5";
            this.$refs.next.style.backgroundColor = "#D2841A";
        },
        hollowColor() {
            // this.$refs.navText.style.color = "#D2841A";
            this.$refs.back.style.backgroundColor = "#459300";
            this.$refs.next.style.backgroundColor = "transparent";
        }

    },
    mounted() {
        this.$refs.back.addEventListener("click", this.back);
        this.$refs.next.addEventListener("click", this.next);
    }
}
</script>

<style>
.arrow-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 100%;
}

.arrow-wrapper {
    height: 100vh;
    width: 100vw;
    /* background-color: purple; */
    position: fixed;
    top: 0;
    left: 0;
    /* z-index: -9; */
    /* background-color: #F0F4F8; */
}

.arrow {
    height: 100%;
    width: 80px;
    box-sizing: border-box;
    border-top: 10px solid #212121;
    border-bottom: 10px solid #212121;
    display: flex;
    justify-content: center;
    /* background-color: yellow; */
    position: relative;
    z-index: 999;
    /* transition: background-color 1s ease-in-out; */
}

.arrow.left {
    left: 0;
    border-right: 1px solid #212121;
    transition: border .2s ease-in-out, background-color .2s ease-in-out;
}

.arrow.right {
    right: 0;
    border-left: 1px solid #212121;
    transition: border .2s ease-in-out, background-color .2s ease-in-out;
}

.arrow img {
    height: 40px;
    width: auto;
    margin: auto;
    position: absolute;
    top: calc(20vh - 70px);
    opacity: .50;
    transition: opacity .3s ease-in-out;
}

.arrow.left img {
    right: 15px;
}

.arrow.right img {
    left: 15px;
}

.arrow.left h1 {
    transform: rotate(-90deg) translateX(-100%);
    transform-origin: top left;
    /* color: #F0F4F8; */
    /* -webkit-text-fill-color: #F0F4F8;
    -webkit-text-stroke-color: #212121;
    -webkit-text-stroke-width: 1px; */
    /* line-height: 80px; */
    line-height: 36px;
    position: absolute;
    font-size: 36px;
    top: calc(19.75vh - 13px);
    /* top: 50%; */
    left: 34px;
    /* right: 0; */
    opacity: 0;
    white-space: nowrap;
    transition: left .2s ease-in-out, opacity .2s ease-in-out;
}

.arrow.right h1 {
    transform: rotate(90deg) translateX(100%);
    transform-origin: top right;
    /* color: #F0F4F8; */
    /* -webkit-text-fill-color: #F0F4F8;
    -webkit-text-stroke-color: #212121;
    -webkit-text-stroke-width: 1px; */
    line-height: 80px;
    position: absolute;
    font-size: 36px;
    top: calc(19.75vh - 13px);
    /* right: 0; */
    right: 10px;
    opacity: 0;
    white-space: nowrap;
    transition: right .2s ease-in-out, opacity .2s ease-in-out;
}

.arrow:hover {
    background-color: #2D7BE5;
}

.arrow:hover img {
    opacity: 1;
}

.arrow.left:hover {
    border-right: 10px solid #212121;
    cursor: pointer;
}

.arrow.left:hover h1 {
    left: 24px;
    opacity: 1;
}

.arrow.right:hover {
    border-left: 10px solid #212121;
    cursor: pointer;
}

.arrow.right:hover h1 {
    right: 0px;
    opacity: 1;
}
</style>